import { Observable } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { get } from "../../../service/api";
import { IUserDto } from "../interface/dto/list-builder-users.dto";

export const fetchListBuilderUsers = (
    tokens: ITokenPair,
): Observable<Array<IUserDto>> =>
    get<Array<IUserDto>>("/common/users", undefined, tokens);
